module.exports = __webpack_public_path__ + "img/ImagineerTypesQuiz_Q4-lockup.11652175.png";